import { CommonModule } from '@angular/common';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { TopbarComponent } from '../../utils/topbar/topbar.component';
import { SidebarComponent } from "../../utils/sidebar/sidebar.component";
import { ToastComponent } from "../../utils/toast/toast.component";
import { IdleUserService } from '../../services/idle.service';
import { ThemeService } from '../../theme.service';

import { ToastNotificationComponent } from '../../utils/toast-notification/toast-notification.component';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ToastService } from '../../services/toast.service';
import { NotificationsService } from '../../services/notifications.service';
import { AppService } from '../../services/app.service';
@Component({
    selector: 'app-layout',
    imports: [TopbarComponent, RouterModule, SidebarComponent, CommonModule, ToastComponent, ToastNotificationComponent, ToastModule],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  isFirstTime = false;
  step = 1;
  titleBar = "";

  isUserIdle: boolean = false;
  _subscription: any;
  nextStep() {
    this.step++;
    if (this.step == 3) {
      this.dismissTour();
    }
  }

  clickOutside(isOut: any) {
    if (isOut) {

    }
  }
  constructor(private router: Router, private idleUserService: IdleUserService, private themeService: ThemeService, private notificationsService: NotificationsService, public toastSvr: ToastService, private appService: AppService,) {
    this.idleUserService.userInactive.subscribe(isIdle => this.isUserIdle = isIdle);

    if (!router.url.includes('dashboard')) {
      this.dismissTour();
    }

    //parseFloat(localStorage.getItem('iaTime')!);
    //parseFloat(localStorage.getItem('timeOut')!);
    if (!localStorage.getItem('iaTime') || !localStorage.getItem('timeOut')) {
      this.getInactivityyTimer();
    }

    this._subscription = themeService.changeTitle.subscribe((value) => {
      setTimeout(() => this.titleBar = value);
    });
  }


  ngOnInit() {
    this.startTourDesktop(false);

  }

  startTourDesktop(force: boolean) {
    if (!localStorage.getItem('xiga-portal-tour') || force) {
      this.isFirstTime = true;
    }
  }


  dismissTour() {
    this.isFirstTime = false;
    if (!localStorage.getItem('xiga-portal-tour')) {
      localStorage.setItem('xiga-portal-tour', 'true');
    }
  }

  getInactivityyTimer() {
    this.appService.checkInactivityTimeout().subscribe({
      next: (resp: any) => {
        let inactivity = (resp.sessionTime - resp.timeToLogOut) * 60;
        localStorage.setItem('iaTime', inactivity.toString());
        localStorage.setItem('timeOut', (resp.timeToLogOut * 60).toString());
      },
      error: (error) => {
              
      }
    });
  }
}
